export default __webpack_public_path__ + "static/rachel-mcshane-2036624752e6022b5989a8e9b8560de7.jpg";